<template>
  <div class="tableCon">
    <lk-table
      v-if="resTable.length > 0"
      :columns='columns'
      :data='resTable'
    ></lk-table>
  </div>
</template>
<script>
import utils from '../../libs/utils';

export default {
  name: 'ReturnExpand',
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
    };
  },
  computed: {
    resTable() {
      return this.tableData.map((item) => {
        const result = {};
        utils.exchangeTable(item, result);
        return result;
      });
    },
  },
};
</script>
<style lang="less" scoped>
 .tableCon {
    padding: 0 40px;
}
</style>

